import { FormattedMessage } from 'react-intl';
import { Text } from '@chakra-ui/react';

export const BooleanItemComponent = ({ value }) => {
  return (
    <Text color="text.accent">
      <FormattedMessage id={`${value}CheckerTableText`} />
    </Text>
  );
};
